// @ts-nocheck

import { debounce } from 'lodash';

const debouncers = {};

export default () => (next) => {
  const getDebouncer = (actionType, { time, options = {} }) => {
    if (!debouncers[actionType]) {
      const debouncer = debounce(next, time, options);
      debouncers[actionType] = debouncer;
    }
    return debouncers[actionType];
  };

  return (action) => {
    if (action) {
      if ('meta' in action) {
        if ('debounce' in action.meta) {
          const debounce = getDebouncer(action.type, action.meta.debounce);
          return debounce(action);
        }
      }
      return next(action);
    }
  };
};
